export default __webpack_public_path__ + "static/media/sciaticaTwo.6c3e9f65.png";